import * as React from "react";
import { JudgeApi, JudgeInformationDto } from "../../../../api";
import { useApiService, useCrudApi, useTl } from "../../../../hooks";
import { useGlobalData } from "../../../../contexts";
import { ERoutes } from "../../../../ERoutes";
import { JudgeIcon } from "./personJudge/JudgeIcon";
import { FieldGroup, FGMultiSuggestInput, FGTextInput, FieldSet } from "nsitools-react";
import { SmallFormGenerator } from "../../../../components";
import { ETLCodes } from "../../../../locales";
import { useReferential } from "../../../../hooks/useReferential";

export interface IPersonJudgeInfoPageProps {
  personId: number;
  editMode: boolean;
}

export const PersonJudgeInfoPage: React.FunctionComponent<IPersonJudgeInfoPageProps> = ({ personId, editMode }) => {
  const judgeApi = useApiService(JudgeApi);

  const { t } = useTl();

  const { data, loading, saveItem, saving } = useCrudApi<JudgeInformationDto>(
    {
      getApiFn: async () => {
        const res = await judgeApi.judgeInformations(personId);
        return res ?? JudgeInformationDto.fromJS({ personId: personId });
      },
      saveApiFn: (d) => judgeApi.saveJudgeInformations(d),
      onSavedRoute: (d) => `${ERoutes.people}/${personId}/judge/edit`,
    },
    []
  );
  const [allLanguagesReferential, allLanguagesReferentialLoading] = useReferential(
    (a) => a.getAllLanguages(),
    true,
    []
  );

  return (
    <FieldSet title={t(ETLCodes.JudgeInformations)}>
      {" "}
      <SmallFormGenerator
        initialValues={data}
        onSubmit={saveItem}
        editMode={editMode}
        loading={loading}
        saving={saving}
      >
        <FieldGroup columns={1}>
          <FGMultiSuggestInput
            label={t(ETLCodes.SpokenLanguages)}
            items={allLanguagesReferential}
            loading={allLanguagesReferentialLoading}
            displayField={"label"}
            valueField={"value"}
            isFilterable={true}
            name="spokenLanguageIds"
          />
          <FGTextInput name="fciNumber" label={t(ETLCodes.FciNumber)} />
        </FieldGroup>
      </SmallFormGenerator>
    </FieldSet>
  );
};
